<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter" id="AWH0">
<section class="chapter" epub:type="chapter" id="section_level_h1_01" role="doc-chapter" title="JANUARY 11: Living for the Eternal">
<h1 class="chapter" id="pABmm"><a href="#/contents#AB_ch12" id="AB_cha12">JANUARY 11<br/><br/> <span class="chapter2">Living for the Eternal</span></a></h1>
<blockquote>
<p class="ext" id="pAyEy"><em>I also count all things loss for the excellence of the knowledge of Christ Jesus my Lord.</em></p>
</blockquote>
<p class="right" id="pAKmy">—Philippians 3:8</p>
<p class="noind" id="A6X-"><span class="dcap"><b>T</b></span>he world offers much that we can enjoy, much that makes us feel valuable, and much that offers status according to the society’s value system. Let’s be thankful for the option of freeing ourselves from this temporal mind-set.</p>
<p id="pA0-">The apostle Paul wrote that he was “circumcised the eighth day, of the stock of Israel, of the tribe of Benjamin, a Hebrew of the Hebrews; concerning the law, a Pharisee; concerning zeal, persecuting the church; concerning the righteousness which is in the law, blameless” (Philippians 3:5–6). Paul had worked hard to be considered righteous according to Mosaic law, and he had indeed gained a place of honor among fellow Jews. Yet as Philippians 3:8 attests, he no longer valued those things the world around him valued.</p>
<p id="pAsy2">Encouraged by Paul’s example, what can you let go of in order to more fully be God’s person? Are you still looking for status from worldly endeavors? Set your mind on eternal things, release yourself from the world’s pressure to conform, and find your freedom in Christ. Then, like Paul, be thankful you have counted “all things loss.”</p>
<p class="left1" id="pADUX"><em>Lord, thank You for this reminder, this wake-up call. Help me live for the eternal. Help me live for You.</em></p>
</section>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chapter12.vue?10c6bf8d